import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';

class PrimaryRepeatButton extends React.Component {

  render() {

    return (
      <PrimaryButton {...this.props} endIcon={<LibraryAddIcon />}>Multiple</PrimaryButton>
    );
  }
}

PrimaryRepeatButton.defaultProps = {
  disabled: false
};

PrimaryRepeatButton.propTypes = {
  dataTest: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(styles)(PrimaryRepeatButton);